<h1>{{ editmode? 'Link categorie wijzigen' : 'Link categorie toevoegen' }}</h1>
<form
  class="standard-form"
  [formGroup]="linkTypeEditForm"
  (ngSubmit)="onSubmit()"
>
  <div class="form-fields">
    <mat-form-field class="form-field">
      <mat-label for="name">Naam</mat-label>
      <input matInput id="name" formControlName="name" />
      @if(linkTypeEditForm.get('name')?.touched &&
      linkTypeEditForm.get('name')?.invalid) {
      <mat-error>Voer een geldige naam in</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-buttons">
    <button
      mat-raised-button
      class="icon-button button-standard-action"
      (click)="onNavigateBack()"
      type="button"
    >
      <mat-icon>keyboard_double_arrow_left</mat-icon>
      Terug
    </button>
    @if(editmode) { 
      <button
      mat-raised-button
      class="button-standard-action"
      (click)="onDelete()"
      type="button"
      >
        Delete
      </button>
    }
    <button
      mat-raised-button
      class="button-standard-action"
      (click)="onReset()"
      type="button"
    >
      Reset
    </button>
    <button mat-raised-button class="button-primary-action" type="submit">
      Opslaan
    </button>
  </div>
</form>
